// Standards descriptions arrive with the tag alias repeated at the start (e.g. "K.HP.1.1 - History").
// Since the alias is shown separately as a pill/tag, strip it (plus any leading separator) from the description.
export default function stripStandardsAliasPrefix(description: string | null, alias: string | null): string {
  if (!description) return '';

  const trimmed = description.trimStart();
  if (alias && trimmed.startsWith(alias)) {
    return trimmed.slice(alias.length).replace(/^[\s.\-–—:]+/, '').trimStart();
  }

  return trimmed.replace(/^[\s.\-–—:]+/, '').trimStart();
}
